import { Tooltip } from "antd";

const InstitutionCardRankCompare = ({
  data,
  candidateList,
  setCandidateList,
  setOpenAdd,
  isCompare,
  candidateIdList,
  setCandidateIdList,
  candidateIndex,
}) => {
  const handleAddItemCompare = () => {
    const newIdList = [...candidateIdList];
    newIdList.splice(candidateIndex, 0, { id: data.id });
    setCandidateIdList(newIdList);
    setOpenAdd(false);
  };
  const handleAddItemRank = () => {
    !candidateList.some((item) => item.id === data.id) &&
      setCandidateList([...candidateList, data]);
  };
  const handleDeleteItemRank = () => {
    const list = candidateList.filter((item) => item.id !== data.id);
    setCandidateList(list);
  };
  return (
    <div
      style={{
        background: "var(--benchmarking-hover)",
        padding: "10px",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          marginBottom: "10px",
        }}
      >
        <div style={{ position: "relative", width: "40px", height: "40px" }}>
          <img
            src={
              data.photo_url
                ? data.photo_url
                : "https://www.openmicroscopy.org/img/icons/user-groups_institutions.svg"
            }
            alt="avatar"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <svg
            style={{
              width: "18px",
              height: "18px",
              position: "absolute",
              right: -3,
              bottom: -3,
            }}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.592 9.46049C16.8463 9.13353 16.7874 8.66232 16.4605 8.40802C16.1335 8.15372 15.6623 8.21262 15.408 8.53958L11.401 13.6914C11.3119 13.806 11.1443 13.8209 11.0364 13.7238L8.50173 11.4426C8.19385 11.1655 7.71963 11.1904 7.44254 11.4983C7.16544 11.8062 7.1904 12.2804 7.49828 12.5575L10.033 14.8387C10.7881 15.5183 11.9613 15.4143 12.585 14.6123L16.592 9.46049Z"
              fill="var(--benchmarking-color)"
            />
          </svg>
        </div>
        <div style={{ marginLeft: "15px" }}>
          <p style={{ fontWeight: "600" }}>{data.inst_name}</p>
        </div>
      </div>
      <p
        style={{
          display: "-webkit-box",
          "-webkit-line-clamp": "3",
          "-webkit-box-orient": "vertical",
          overflow: "hidden",
        }}
      >
        {data.bio}
      </p>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {isCompare ? (
          <Tooltip
            title={
              Object.values(candidateList).some(
                (obj) => obj?.data.id === data.id
              )
                ? "Already on list"
                : "Add to compare"
            }
          >
            {Object.values(candidateList).some(
              (obj) => obj?.data.id === data.id
            ) ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={"add-compare-button-check"}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.592 9.46049C16.8463 9.13353 16.7874 8.66232 16.4605 8.40802C16.1335 8.15372 15.6623 8.21262 15.408 8.53958L11.401 13.6914C11.3119 13.806 11.1443 13.8209 11.0364 13.7238L8.50173 11.4426C8.19385 11.1655 7.71963 11.1904 7.44254 11.4983C7.16544 11.8062 7.1904 12.2804 7.49828 12.5575L10.033 14.8387C10.7881 15.5183 11.9613 15.4143 12.585 14.6123L16.592 9.46049Z"
                />
              </svg>
            ) : (
              <svg
                onClick={() => handleAddItemCompare()}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={"add-compare-button"}
              >
                <path
                  d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="add-compare-path"
                />
              </svg>
            )}
          </Tooltip>
        ) : (
          <Tooltip
            title={
              candidateList.some((item) => item.id === data.id)
                ? "Already on list"
                : "Add to compare"
            }
          >
            {candidateList.some((item) => item.id === data.id) ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={"add-compare-button-check"}
                onClick={handleDeleteItemRank}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.592 9.46049C16.8463 9.13353 16.7874 8.66232 16.4605 8.40802C16.1335 8.15372 15.6623 8.21262 15.408 8.53958L11.401 13.6914C11.3119 13.806 11.1443 13.8209 11.0364 13.7238L8.50173 11.4426C8.19385 11.1655 7.71963 11.1904 7.44254 11.4983C7.16544 11.8062 7.1904 12.2804 7.49828 12.5575L10.033 14.8387C10.7881 15.5183 11.9613 15.4143 12.585 14.6123L16.592 9.46049Z"
                />
              </svg>
            ) : (
              <svg
                onClick={handleAddItemRank}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={"add-compare-button"}
              >
                <path
                  d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="add-compare-path"
                />
              </svg>
            )}
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default InstitutionCardRankCompare;
